(() => {
  'use strict';
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const image = document.getElementById('color-animation');
  const toggle = document.getElementById('color-animation-toggle');
  let wantsAnimation = !motion.matches;
  let imageVisible = false;
  function updateAnimation() {
    if (!image || !toggle) return;
    const playing = wantsAnimation && imageVisible && !document.hidden;
    const source = playing ? image.dataset.animationSrc : image.dataset.stillSrc;
    if (image.getAttribute('src') !== source) image.src = source;
    toggle.textContent = wantsAnimation ? '動きを止める' : '動きを見る';
    toggle.setAttribute('aria-pressed', String(wantsAnimation));
  }
  if (image && toggle) {
    toggle.hidden = false;
    toggle.addEventListener('click', () => { wantsAnimation = !wantsAnimation; updateAnimation(); });
    motion.addEventListener('change', () => { wantsAnimation = !motion.matches; updateAnimation(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(entries => { imageVisible = entries[0].isIntersecting; updateAnimation(); }).observe(image);
    } else { imageVisible = true; }
    updateAnimation();
  }
  const videos = Array.from(document.querySelectorAll('#intro-dogs-video, #material-dogs-video'));
  const visible = new WeakMap();
  function updateVideo(video) {
    if (!visible.get(video) || document.hidden) { video.pause(); return; }
    const source = video.querySelector('source[data-src]');
    if (source) { source.src = source.dataset.src; source.removeAttribute('data-src'); video.load(); }
    video.muted = true;
    const playback = video.play();
    if (playback && playback.catch) playback.catch(() => {});
  }
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      visible.set(entry.target, entry.isIntersecting); updateVideo(entry.target);
    }), { threshold: 0 });
    videos.forEach(video => { video.muted = true; video.pause(); observer.observe(video); });
  }
  document.addEventListener('visibilitychange', () => {
    updateAnimation(); videos.forEach(updateVideo);
  });
})();
